import { render, staticRenderFns } from "./CouponSendList.vue?vue&type=template&id=011c775b"
import script from "./CouponSendList.vue?vue&type=script&lang=ts"
export * from "./CouponSendList.vue?vue&type=script&lang=ts"
import style0 from "./CouponSendList.vue?vue&type=style&index=0&id=011c775b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports